<template>
  <b-form :inline="isInline" @submit.prevent="onSubmit">
    <!-- <pre>{{localDateParam}}</pre> -->
    <label for="analyticInterval" class="sr-only">Interval</label>
    <select
      class="form-control mr-3 mb-0"
      id="analyticInterval"
      v-model="selected.dateInterval"
      v-if="enableInterval"
      @change="intervalChanged">
      <option
        v-for="item in intervalOptions"
        v-bind:key="`interval-${item.value}`"
        :value="item.value"
        :disabled="item.selectable === false">
        {{ item.label }}
      </option>
    </select>
    <!-- <DatePicker v-model='start' /> -->
    <date-time-picker
        ref="pickie"
        v-if="selected.range"
        v-model="selected.range"
        is-range
        :masks="masks"
        input-class="ml-3 mr-3 form-control"
        input-style="min-width: 320px"
        @input="dateSelected"
      >
      <template v-slot:footer>
        <div class="text-center p-2">
          <button
            class="btn btn-warning btn-md"
            @click.prevent="closePopup"
            >
            Done
          </button>
        </div>
      </template>
    </date-time-picker>
    <select
      class="form-control mr-3 mb-0"
      id="dataInterval"
      v-model="selected.dataInterval"
      @change="dataIntervalChanged">
      <option
        v-for="(item, index) in dataIntervalOptions"
        v-bind:key="`interval-${index}`"
        :value="item.value">
        {{ item.label }}
      </option>
    </select>
    <b-button
      variant="primary"
      size="md"
      type="submit"
      :disabled="isLoading">
      <i class="fa" :class="isLoading ? 'ri-loader-line' : 'ri-search-line'"></i>
      Apply
    </b-button>
    <small v-if="pointHint" class="text-warning ml-3">{{ pointHint }}</small>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import dateUtil from '@/util/date';
import DateTimePicker from './DateTimePicker.vue';

export default {
  name: 'date-picker',
  components: {
    DateTimePicker,
  },
  props: ['isInline', 'isLoading', 'enableInterval', 'dateParam', 'isSingleEngine'],
  data() {
    return {
      masks: 'YYYY-MM-DD h:mm A',
      dataIntervalOptions: dateUtil.dataIntervalOptions,
      intervalOptions: dateUtil.intervals,
      dateRange: undefined,
      selected: {
        dateInterval: undefined,
        dataInterval: undefined,
        range: undefined,
      },
      localDateParam: undefined,
      lastSuggestedInterval: undefined,
    };
  },
  validations: {
    start: {
      required,
    },
    end: {
      required,
    },
  },
  computed: {
    pointCount() {
      if (!this.localDateParam || !this.localDateParam.range) return 0;
      return dateUtil.estimatePoints(this.localDateParam.range, this.selected.dataInterval);
    },
    pointHint() {
      if (this.pointCount <= 1500) return '';
      return `~${this.pointCount.toLocaleString('en-US')} points — this may take a while`;
    },
  },
  methods: {
    closePopup() {
      this.$nextTick(() => {
        // console.log('Close...', this.$refs.pickie);
        this.$refs.pickie.hidePopover();
        // this.visibility = 'hidden';
      });
      // this.$nextTick(() => this.$refs.pickie.$el.blur());
    },
    dateSelected() {
      this.selected.dateInterval = 'custom';
      this.localDateParam.range.start = this.selected.range.start.getTime();
      this.localDateParam.range.end = this.selected.range.end.getTime();
      // Cuma timpa kalau sarannya berubah, biar pilihan manual user ga kereset.
      const suggested = dateUtil.suggestIntervalFor(this.localDateParam.range);
      if (suggested && suggested !== this.lastSuggestedInterval) {
        this.lastSuggestedInterval = suggested;
        this.selected.dataInterval = suggested;
        this.localDateParam.aggregatedUnit = suggested;
      }
    },
    intervalChanged() {
      this.localDateParam = dateUtil.byInterval(this.selected.dateInterval);
      this.selected.range = this.toDateRange(this.localDateParam.range);
      this.selected.dataInterval = this.localDateParam.aggregatedUnit;
      console.log('Interval changed... ', this.localDateParam);
    },
    toDateRange(range) {
      return range ? { start: new Date(range.start), end: new Date(range.end) } : undefined;
    },
    dataIntervalChanged() {
      console.log('DataInterval changed... ', this.selected.dataInterval);
      this.localDateParam.aggregatedUnit = this.selected.dataInterval;
      // this.selected.dataInterval = this.localDateParam.aggregatedUnit;
    },
    onSubmit() {
      this.$emit('onSubmitRange', this.localDateParam);
    },
  },
  mounted() {
    // console.log('Datepicker mounted using param : ', this.dateParam);
    this.localDateParam = this.dateParam;
    this.selected.dateInterval = this.localDateParam.value;
    this.selected.dataInterval = this.localDateParam.aggregatedUnit;
    this.selected.range = this.toDateRange(this.localDateParam.range);
  },
};
</script>
